module.exports = __webpack_public_path__ + "img/flexepin.18e6b73d.svg";